import React, { useState } from "react";
import { Input, Modal, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/zh-tw";

interface MuiDateTimePickerProps {
  value?: Dayjs | null;
  onChange?: (date: Dayjs | null) => void;
  placeholder?: string;
  format?: string;
  disabledDate?: (date: Dayjs) => boolean;
  style?: React.CSSProperties;
}

const MuiDateTimePickerComponent: React.FC<MuiDateTimePickerProps> = ({
  value,
  onChange,
  placeholder = "Select date and time",
  format = "ddd, MMM DD, HH:mm",
  disabledDate,
  style,
}) => {
  const [open, setOpen] = useState(false);
  const [tempValue, setTempValue] = useState<Dayjs | null>(value || null);

  const handleOpen = () => {
    setTempValue(value || dayjs());
    setOpen(true);
  };

  const handleAccept = () => {
    onChange?.(tempValue);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Input
        value={value ? value.format(format) : ""}
        placeholder={placeholder}
        readOnly
        onClick={handleOpen}
        suffix={<CalendarOutlined />}
        size="large"
        style={{
          cursor: "pointer",
          ...style,
        }}
      />

      <Modal
        open={open}
        onCancel={handleCancel}
        width="auto"
        centered
        styles={{
          body: {
            padding: 0,
          },
        }}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="ok" type="primary" onClick={handleAccept}>
            OK
          </Button>,
        ]}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-tw">
          <StaticDateTimePicker
            value={tempValue}
            onChange={(newValue) => setTempValue(newValue)}
            shouldDisableDate={disabledDate}
            ampm={false}
            minutesStep={5}
            slots={{
              actionBar: () => null,
            }}
          />
        </LocalizationProvider>
      </Modal>
    </>
  );
};

export default MuiDateTimePickerComponent;
